var order_number = 0;
$(document).ready(function () {

   $(document).on('change','.quickadd-wrapper .quick_add__input--dropdown select', function(){
    let current_variant = $(this).val();   
    $(this).parents('.quick-add').find( "product-form form input[name='id']").val(current_variant);
  });

  $(document).on('click','.is-banner-inner-main', function(){
      var pagehandle = $(".product_left_side").offset().top - 100;
  
      $('html, body').animate({
        scrollTop: pagehandle
      }, 1000);
    // }
  });
  
  $('input[name="properties[AHV-Nr.]"]').inputmask("999.9999.9999.99");
  
  jQuery.extend(jQuery.validator.messages, {
    required: "Dieses Feld ist erforderlich.",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    accept: "Bitte fügen Sie einen gültigen Dateityp hinzu.",
    maxlength: "Diese Telefonnummer ist unvollständig."
  });
  
  settings = {
    //Model Popup
    objModalPopupBtn: ".modalButton",
    objModalCloseBtn: ".overlay, .closeBtn",
    objModalDataAttr: "data-popup",
  };

  $(document).on("click",settings.objModalPopupBtn, function () {
    event.preventDefault();
    if ($(this).attr(settings.objModalDataAttr)) {
      var strDataPopupName = $(this).attr(settings.objModalDataAttr);
      //Fade In Modal Pop Up
      $("#" + strDataPopupName).fadeIn();
      $(".overlay").first().fadeIn();
      $("body").addClass("open-modal");
      order_number = Math.floor(Math.random() * 10000000000);
      setTimeout(function () {
        destroyCarousel();
        loadSelect();
      }, 500);
    }
  });

  //On clicking the modal background
  $(document).on("click",settings.objModalCloseBtn, function () {
    $(".product-form").find("div#form_success").addClass("hidden");
    $(".product-form").find("div#form_error").addClass("hidden");
    $("body").removeClass("open-modal");
    $(".modal").fadeOut();
    $(".btn-out-of-stock").removeClass("loading");
    $(".btn-out-of-stock").find(".loading-overlay__spinner").addClass("hidden");
    $(".btn-out-of-stock").attr("aria-disabled", false);
    $(".btn-out-of-stock").attr("disabled", false);

    $(".form.product-form").find(".product-options-form").removeClass("hidden");
    $(".form.product-form").find(".product-checkout-form").addClass("hidden");
    $(".form.product-form").find(".btn-out-of-stock").addClass("hidden");
    $(".form.product-form").find(".product-checkout-form").find(".booking_input").attr("disabled", true);
  });

  $(document).on("click", ".next-step-button", function () {
    var $this = $(this);
    var $form = $this.parents(".form").attr("id");
    if (jQuery("form#" + $form).valid()) {
      $("#" + $form).children(".form-input-wrapper").children(".product-options-form").addClass("hidden");
      $("#" + $form).children(".form-input-wrapper").children(".product-checkout-form").removeClass("hidden");
      $("#" + $form).children(".form-input-wrapper").children(".btn-out-of-stock").removeClass("hidden");
      $("#" + $form).children(".form-input-wrapper").children(".btn-in-stock").removeClass("hidden");

      $("#" + $form).children(".form-input-wrapper").children(".product-checkout-form").find(".booking_input").attr("disabled", false);
    }
  });

  $(document).on("click", ".btn-out-of-stock", function () {
    var $this = $(this);
    var $form = $this.parents(".form").attr("id");
    if (jQuery("form#" + $form).valid()) {
      var form_product_name = $("#" + $form).find('[name="form_product_name"]').val();
      var form_product_id = $("#" + $form).find('[name="form_product_id"]').val();
      var form_product_qty = $("#" + $form).find('[name="form_product_qty"]').val();
      var form_product_sku = $("#" + $form).find('[name="form_product_sku"]').val();
      var product_price = $("#" + $form).find('[name="product_price"]').val();
      
      var geschlecht = $('#'+$form).find('[name="properties[Geschlecht]"]:checked').val();
      var vorname = $('#'+$form).find('[name="properties[Kind-Vorname]"]').val();
      var name = $('#'+$form).find('[name="properties[Kind-Name]"]').val();
      var Strasse = $('#'+$form).find('[name="properties[Kind-Strasse]"]').val();
      var PLZ = $('#'+$form).find('[name="properties[Kind-PLZ]"]').val();
      var Ort = $('#'+$form).find('[name="properties[Kind-Ort]"]').val();
      var Geburtsdatum = $('#'+$form).find('[name="properties[Kind-Geburtstag]"]').val();
      var Mobile = $('#'+$form).find('[name="properties[Mobile]"]').val();
      var weitere_Mobile = $('#'+$form).find('[name="properties[weitere Mobile]"]').val();
      var E_Mail = $('#'+$form).find('[name="properties[Email]"]').val();
      var ahv_nr = $('#'+$form).find('[name="properties[AHV-Nr.]"]').val();
      var kleindergrosse = $('#'+$form).find('[name="properties[Kleidergrösse]"]:checked').val();
      var allergien = $('#'+$form).find('[name="properties[Krankheiten/Allergien]"]').val();
      var Esspraferenzen = $('#'+$form).find('[name="properties[Esspräferenzen]"]:checked').val();
      var Spielt_aktiv_Fussbal = $('#'+$form).find('[name="properties[Spielt aktiv Fussbal]"]:checked').val();
      var camp_details = $('#'+$form).find('[name="properties[Details]"]').val();
      var Ich_mochte_im_Team = $('#'+$form).find('[name="properties[Ich möchte im Team sein mit]"]').val();
      var Bemerkungen = $('#'+$form).find('[name="properties[Bemerkungen]"]').val();
      var Grund = $('#'+$form).find('[name="Grund"]').val();

      var checkout_fname = $('#'+$form).find('[name="checkout-first-name"]').val();
      var checkout_lname = $('#'+$form).find('[name="checkout-last-name"]').val();
      var checkout_strasse = $('#'+$form).find('[name="checkout-Strasse"]').val();
      var checkout_additional_address = $('#'+$form).find('[name="checkout-additional-address"]').val();
      var checkout_plz = $('#'+$form).find('[name="checkout-PLZ"]').val();
      var checkout_ort = $('#'+$form).find('[name="checkout-Ort"]').val();

      if(typeof Esspraferenzen === 'undefined'){
        Esspraferenzen = '';
      }

      if(typeof Spielt_aktiv_Fussbal === 'undefined'){
        Spielt_aktiv_Fussbal = '';
      }

      var b2c={
      "checkout_type": "waiting-list",
      "data": {
          "attributes": {
            "x-shopify-shop-domain":"fcsgweb.myshopify.com",
            "order_number": order_number,
            "name": form_product_name,
            "product_id": form_product_id,
            "quantity": form_product_qty,
            "sku": form_product_sku,
            "price": product_price,
            "checkout_vorname": checkout_fname,
            "checkout_nachname": checkout_lname,
            "checkout_strasse_und_hausnummer": checkout_strasse,
            "checkout_additional_address_2": checkout_additional_address,
            "checkout_plz": checkout_plz,
            "checkout_ort": checkout_ort,
            
          },
          'properties':[
            {
              "name": "Kind-Vorname",
              "value": vorname
            },
            {
              "name": "Kind-Name",
              "value": name
            },
            {
              "name":"Geschlecht",
              "value": geschlecht
            },
            {
              "name": "Kind-Strasse",
              "value": Strasse
            },
            {
              "name": "Kind-PLZ",
              "value": PLZ
            },
            {
              "name": "Kind-Ort",
              "value": Ort
            },
            {
              "name": "Kind-Geburtstag",
              "value": Geburtsdatum
            },
            {
              "name": "AHV-Nummer",
              "value": ahv_nr
            },
            {
              "name": "Mobile",
              "value": Mobile
            },
            {
              "name": "weitere Mobile",
              "value": weitere_Mobile
            },
            {
              "name": "Email",
              "value": E_Mail
            },
            {
              "name": "Kleidergrösse",
              "value": kleindergrosse
            },
            {
              "name": "Krankheiten / Allergien",
              "value": allergien
            },
            {
              "name": "Esspräferenzen",
              "value": Esspraferenzen
            },
            {
              "name": "Spielt aktiv Fussbal?",
              "value": Spielt_aktiv_Fussbal
            },
            {
              "name": "Ich möchte im Team sein mit",
              "value": Ich_mochte_im_Team
            },
            {
              "name": "Bemerkungen",
              "value": Bemerkungen
            },
            {
              "name":"Grund",
              "value":Grund
            },
            {
              "name":"Camp-details",
              "value": camp_details
            }
          ],
          'status': 'success'
      }
    }

    console.log(JSON.stringify(b2c));
    
    $.ajax({
        url: `${API_URL}ecommerce-orders/custom-checkout`,
        type: "POST",
        data: JSON.stringify(b2c),
        headers:{"Accept":'application/vnd.api+json', 'Content-type':'application/vnd.api+json'},
        beforeSend: function(){
          $this.addClass('loading');
          $this.find('.loading-overlay__spinner').removeClass('hidden');
          $this.attr('aria-disabled',true);
          $this.attr('disabled',true);
        },
        success: function (data) {
          $('#'+$form).find('div#form_success').removeClass('hidden');
          setTimeout(function(){
              $(".modal").fadeOut();
              // location.reload();
            },3000);
        },
        complete:function(){
          $this.removeClass('loading');
          $this.find('.loading-overlay__spinner').addClass('hidden');
          $this.attr('aria-disabled',false);
          $this.attr('disabled',false);
        },
        error:function(jqXHR, textStatus, errorThrown ){
          $('#'+$form).find('div#form_error').removeClass('hidden');
          $this.removeClass('loading');
          $this.find('.loading-overlay__spinner').addClass('hidden');
          $this.attr('aria-disabled',false);
          $this.attr('disabled',false);
        }
      });
    }
  });
});
function loadSelect() {
  $(".product-slider").slick({
    dots: false,
    infinite: false,
    // speed: 300,
    // slidesToShow: {{ section.settings.columns_desktop }},
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow:'<button class="slide-arrow prev-arrow"><span class="icon prevArrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g transform="rotate(180 24 24)"><defs><mask id="ipSRightC0"><g fill="none" stroke-linejoin="round" stroke-width="4"><path fill="#fff" stroke="#fff" d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4S4 12.954 4 24s8.954 20 20 20Z"/><path stroke="#000" stroke-linecap="round" d="m21 33l9-9l-9-9"/></g></mask></defs><path fill="currentColor" d="M0 0h48v48H0z" mask="url(#ipSRightC0)"/></g></svg></span></button>',
    nextArrow:'<button class="slide-arrow next-arrow"><span class="icon nextArrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><defs><mask id="ipSRightC0"><g fill="none" stroke-linejoin="round" stroke-width="4"><path fill="#fff" stroke="#fff" d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4S4 12.954 4 24s8.954 20 20 20Z"/><path stroke="#000" stroke-linecap="round" d="m21 33l9-9l-9-9"/></g></mask></defs><path fill="currentColor" d="M0 0h48v48H0z" mask="url(#ipSRightC0)"/></svg></span></button>',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
}
function destroyCarousel() {
  if ($('.product-slider').hasClass('slick-initialized')) {
    $('.product-slider').slick('destroy');
  }
}
function getFormatedDate(dt) {
  var tempDate = new Date(dt);
  var dy = tempDate.getDate();
  var m = tempDate.getMonth() + 1;

  if (dy < 9) {
    dy = "0" + dy;
  }
  if (m < 9) {
    m = "0" + m;
  }
  var formattedDate = [dy, m, tempDate.getFullYear()].join("/");
  return formattedDate;
}

function makeTimer(countdownTime) {
    var camp_date = countdownTime.split(" ");
    var camp_newdate = camp_date[0].split(".").reverse().join("/");
    var camp_newdate_time = camp_newdate + ' ' + camp_date[1];
    var endTime = new Date(camp_newdate_time);
  
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' });  
  
    now = (Date.parse(now) / 1000);
    var timeLeft = endTime - now; 
  
    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
    var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
    var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

    // days = days < 10 ? "0" + days : days;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    var isExpired = false;
    if (timeLeft <= 0) {
      isExpired = true;
    }
    return [days, hours, minutes, seconds, isExpired]
}